import VueRouter from 'vue-router';

export default new VueRouter({
	// mode: 'history',
	routes: [
        {
			path: '/',
			component: () => import('@/views/home/index.vue'),
			class: 'icon-zu3',
			name: 'home',
			navName: '报名表列表',
			meta: {
				title: '映目-报名表列表',
			},
            redirect: '/question',
            children: [
                {
                    path: '/question',
                    component: () => import('@/views/home/question.vue'),
                    name: 'question',
                    navName: '报名表列表',
                    meta: {
                        title: '映目-报名表列表',
                    },
                },
            ]
		},
		{
			path: '/list',
			component: () => import('@/views/user/questionnaire.vue'),
			class: 'icon-zu3',
			name: 'questionnaire',
			navName: '报名表列表',
            redirect: '/',
			meta: {
				title: '映目-报名表',
			},
		},
		//用户投票页面
		{
			path: '/questionnaireVote/:id/:handle',
			name: 'questionnaireVote',
			component: () => import('@/views/questionnaireVote.vue'),
		},
		{
			path: '/projectCount/:surveyId/:source',
			name: 'projectCount',
			component: () => import('@/views/questionList/projectCount.vue'),
		},
		{
			path: '/setQuestionnaire/:id/:handle/:type',
			component: () => import('@/views/user/setQuestionnaire.vue'),
			class: 'icon-setting',
			navName: '报名表-编辑与管理',
			name: 'setQuestionnaire',
			hidden: true,
		},
		{
			path: '/questionnaireDataStatistics/:id',
			component: () => import('@/views/user/questionnaireDataStatistics.vue'),
			class: 'icon-setting',
			navName: '报名表-数据统计',
			name: 'questionnaireDataStatistics',
			hidden: true,
		},
		{
			path: '/questionnaireDataStatisticsEdit/:id/:source/:handle/:oldMark',
			component: () => import('@/views/user/questionnaireDataStatisticsEdit.vue'),
			class: 'icon-setting',
			navName: '报名表-数据统计-查看编辑',
			name: 'questionnaireDataStatisticsEdit',
			hidden: true,
		},
	],
	scrollBehavior(to, from, savedPosition) {
		return { x: 0, y: 0 };
	},
	base: '/questionnaire/',
});
